export var AIType;
(function (AIType) {
    AIType["BanditManchot"] = "BANDIT_MANCHOT";
    AIType["AdaptiveTest"] = "ADAPTIVE_TEST";
    AIType["CNEDAdaptiveTest"] = "CNED_ADAPTIVE_TEST";
    AIType["RevisionManager"] = "REVISION_MANAGER";
})(AIType || (AIType = {}));
//# sourceMappingURL=types.js.map